import { extendObservable, action } from 'mobx';

import DocumentApi from '../psuite-js/apis/delivery/document';

class DeliveryStore {

    constructor() {
        extendObservable(this, {
            documents: {},

            timeout_to_sync: null,
            time_to_sync: 6000,

            active_section: 'active',

            fetching: false,
            fetch_cancel_source: null,

            is_fetched: false,

            fetched: { active: false, pending: false, done: false },

            limit: 50,
            last_fetch_length: 0,

            fetch: action(this.fetch.bind(this)),
            finish: action(this.finish.bind(this)),
            active: action(this.active.bind(this)),

            updated_at: new Date(),
            finishing: false,
            finishing_all: false,
            activating: false,

            activeSection: action(this.activeSection.bind(this))
        });
    }

    getIndexById(delivery_uid) {
        const documents = Object.values(this.documents);
        return documents.findIndex(delivery => delivery.uid === delivery_uid);
    }

    activeSection(section) {
        this.active_section = section;
    }

    getDocument(id) {
        return Object.values(this.documents).find(document => document.id === id);
    }

    async fetch(params = {}, quiet = false) {
        if (this.fetch_cancel_source) {
            this.fetch_cancel_source.cancel();
        }

        this.fetching = !quiet;

        params.limit = this.limit;
        params.filter = params.filter || {};
        params.order = params.order || [['vehicle', 'user', 'display_name', 'asc'], ['deliveries', 'planned_sequence', 'asc']];
        params.cancelToken = this.fetch_cancel_source = DocumentApi.getCancelSource();

        const response = await DocumentApi.all(params);

        if (response.status === 200) {
            const documents = response.data.data || [];
            this.last_fetch_length = documents.length;

            documents.forEach(document => {
                const id = document.id;
                const parsed_document = this.parseDocument(document);
                this.documents[id] = parsed_document;
            });

            this.updated_at = new Date();
        }

        this.is_fetched = true;
        this.fetching = false;
        this.fetch_cancel_source = null;
        this.fetched[this.active_section] = true;

        return response;
    }

    parseDocument(document) {
        // const deliveries = this.getDeliveriesByCustomers(document);
        const deliveries = document.deliveries;
        const vehicle = document.vehicle || {};
        const total_deliveries = deliveries.length;

        // const done_deliveries = deliveries.filter(delivery => {
        //     const customers = delivery.customers || [];
        //     const dones = customers.filter(customer => (customer.status === 'delivered' || customer.status === 'out_of_plan'));

        //     return (dones.length === customers.length);
        // });

        const done_deliveries = document.deliveries.filter(delivery => (delivery.status !== 'pending' && delivery.status !== 'canceled' && delivery.status !== 'arrived'));
        const total_done_deliveries = done_deliveries.length;

        document.done_deliveries = done_deliveries;
        document.deliveries_returns = document.deliveries.filter(delivery => delivery.status === 'canceled');
        document.warnings = 0;

        document.weight_occupation = Math.round(document.weight * 100 / vehicle.trunk_weight);
        document.volume_occupation = Math.round(document.volume * 100 / vehicle.trunk_volume);

        document.partial = {
            done: total_done_deliveries,
            total: total_deliveries,
            percent: total_done_deliveries * 100 / total_deliveries
        };

        return document;
    }

    getDeliveriesByCustomers(document) {
        const deliveries = document.deliveries;
        const customers = {};

        deliveries.forEach(delivery => {
            if (!customers[delivery.customer_id]) {
                delivery.customers = [];
                customers[delivery.customer_id] = delivery;
            }

            customers[delivery.customer_id].customers.push(delivery);
        });

        return Object.values(customers);
    }

    async finish(document) {
        this.finishing = true;
        const id = document.id;

        const response = await DocumentApi.finish(document.id);

        if (response.status === 200) {
            this.documents[id].status = 'done';
            this.updated_at = new Date();
        }

        this.finishing = false;
        return response;
    }

    async finishAll(data) {
        this.finishing_all = true;

        const response = await DocumentApi.finishAll(data);

        if (response.status === 200) {
            data.document_ids.forEach((document) => {
                const doc = this.documents[document];
                if (doc) {
                    doc.status = 'done';
                }
            });
            this.updated_at = new Date();
        }

        this.finishing_all = false;
        return response;
    }

    async active(document) {
        this.activating = true;
        const id = document.id;

        const response = await DocumentApi.active(document.id, { vehicle_id: document.vehicle_id });

        if (response.status === 200) {
            this.documents[id].status = 'active';
            this.updated_at = new Date();
        }

        this.activating = false;
        return response;
    }
}

export default new DeliveryStore();



// WEBPACK FOOTER //
// ./src/stores/document.js